import React, { Component, useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';
import Pagination from '../../Pagination/Paginations';
import EntriesSelector from '../../Pagination/EntriesSelector';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
statisticsAction,
statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import { event } from 'jquery';
const Holiday = (props) => {
const sparkline1 = React.createRef();
const sparkline2 = React.createRef();
const sparkline3 = React.createRef();
const sparkline4 = React.createRef();


const handleStatistics = (e) => {
statisticsAction(e)
}
const closeStatistics = (e) => {
statisticsCloseAction(e)
}

const { fixNavbar, statisticsOpen, statisticsClose } = props;
const emptyUser={
event_name: "",
start_date: "",
end_date: ""
}

const [user, setUser] = useState({
event_name: "",
start_date: "",
end_date: "",
status:"",
})

const handelInput = (event) => {
	event.preventDefault();
	const { name, value } = event.target;
	console.log(name, value)
	setUser({ ...user, [name]: value });
}



const [url_name, setUrlname] = useState('');
const [url_id, setUrlid] = useState('');
const [url_link, setUrllink] = useState('');
const [parent, setParent] = useState('');
const history = useHistory();
const [data, setData] = useState([]);
const [datacount, setDataCount] = useState([]);
const [dataval, setdataval] = useState([]);
const [currentPageId, setCurrentPageId] = useState(1);
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [table, setTable] = useState([]);

const [formData, setFormData] = useState({
event_name: '',
start_date: '',
end_date:'',
});


const handleChange = (e) => {

const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
// const [anand, setAnand]= useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
const [isSaving, setIsSaving] = useState(false);
const [isUpdating, setIsUpdating] = useState(false);
const savingRef = useRef(false);
const updatingRef = useRef(false);
// const itemsPerPage = 10;
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
let filteredItems = table.filter((item) =>



`${item.event_name.toLowerCase()}${item.event_name.toLowerCase()}${item.start_date.toLowerCase()}`.includes(searchTerm.toLowerCase())

);
const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
const startIndex = (currentPage - 1) * itemsPerPage;
const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

useEffect(() => {
setCurrentPage(1);
}, [searchTerm]);

const handleSearch = (event) => {
setSearchTerm(event.target.value);
};


const clearInput = () => {
setSearchTerm("");
};





useEffect(() => {

	axios
	.get(API_BASE_URL+'/getholidays', {
	headers: 
	{ 
	Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
	}
	})
	.then((response) => {
	console.log(response.data.data.holiday);
	setTable(response.data.data.holiday);
	setData(response.data.data.holiday);


	setLoading(false);
	})
	.catch((error) => {
	setError(error.message);
	setLoading(false);
	});
	}, []);


useEffect(() => {
handleUpdate();
}, []);

var elements = [];
for (var i = 1; i <= datacount.total_page; i++) {
elements.push(i);
}

//   for(var i=1;i<=datacount.total_page;i++){
// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
// 	  {i}
//   </a></li>);
// }

//console.log(elements)

//   const [currentPage,setCurrentPage]= useState(1);
const recordsPerPage = 10;

const lastIndex = currentPage * recordsPerPage;
const firstIndex = lastIndex - recordsPerPage;
const records = data.slice(firstIndex, lastIndex);
const npage = Math.ceil(data.length / recordsPerPage);
const numbers = [...Array(npage + 1).keys()].slice(1);




// const paginate= (page) => setCurrentPage(page);

const handleUpdate = async (holiday_id) => {

axios.get(API_BASE_URL + '/showholidays/' + holiday_id, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
})
.then(res1 => setUser(res1.data))
.catch(err => console.log(err))
};


const handlePagination = async (numpage) => {
// alert('hi');
// alert(numpage);
axios.get(API_BASE_URL + '/fetchurl?per_page=10&page_num=' + numpage, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
})
.then(res1 => setData(res1.data))
.catch(err => console.log(err))
};

//    useEffect(() => {
// 	handlePagination(1);
//   }, []);


const handleSubmit = async (e) => {

e.preventDefault();

// block repeat submits while a save request is already running
if (savingRef.current) return;

savingRef.current = true;
setIsSaving(true);

// setError(null);
// setLoading(true);
// e.preventDefault();
axios.post(API_BASE_URL + '/add_holiday', formData, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
}).then(response => {
// 	console.log(response.data);
// 	console.log(response.data.message);
// })


var status = response.data.status;

if (status=='success')
{
toast.success(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
setTimeout(() => {
window.location.reload(); // Reload the page after delay
}, 3000);

}
else if (status=='error')
{
savingRef.current = false;
setIsSaving(false);
toast.error(response.data.message, {
toastId: "add-holiday", // stops the same error stacking on repeat clicks
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
// setTimeout(() => {
//   window.location.reload(); // Reload the page after delay
// }, 3000);

}
else
{
savingRef.current = false;
setIsSaving(false);
}
}).catch(error => {

// console.log(error);
// console.log(error.response.data.message);
savingRef.current = false;
setIsSaving(false);
toast.error(error.response.data.message, {
toastId: "add-holiday",
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});

});



};



const handleEditSubmit = (e) => {

e.preventDefault();

// block repeat submits while an update request is already running
if (updatingRef.current) return;

updatingRef.current = true;
setIsUpdating(true);

console.log(user);
// setError(null);
// setLoading(true);
// e.preventDefault();
axios.post(API_BASE_URL + '/updateholiday', {holiday_id: user.holiday_id,  event_name: user.event_name, start_date: user.start_date, end_date: user.end_date, status: user.status,is_publish: user.is_publish }, {
headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
}).then(response => {
// console.log(response.data);
// // 	console.log(response.data.message);
//  })


var status = response.data.status;

if (status=='success')
{
toast.success(response.data.message, {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
setTimeout(() => {
window.location.reload(); // Reload the page after delay
}, 3000);

}
else if (status=='error')
{
updatingRef.current = false;
setIsUpdating(false);
toast.error(response.data.message, {
toastId: "update-holiday", // stops the same error stacking on repeat clicks
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});
// setTimeout(() => {
//   window.location.reload(); // Reload the page after delay
// }, 3000);

}
else
{
updatingRef.current = false;
setIsUpdating(false);
}
}).catch(error => {

// console.log(error);
// console.log(error.response.data.message);
updatingRef.current = false;
setIsUpdating(false);
toast.error(error.response.data.message, {
toastId: "update-holiday",
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
theme: "colored",
});

});

};






return (
<>


<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<div className="container-fluid">

<ToastContainer />
<h3 className="card-title d-flex align-items-center mb-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
<i className="fa fa-calendar mr-2" style={{ fontSize: "20px" }} />
Add Holiday
</h3>

<form onSubmit={handleSubmit}>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix">
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Event Name</label>


<div className="form-group required-tooltip">
<input type="text" className="form-control required-input" name="event_name" value={formData.event_name}
	onChange={handleChange} placeholder="Event Name" />
</div>


</div>
</div>
<div className="col-lg-4 col-md-12">
<label>Start Date</label>

<div className="form-group required-tooltip">

<input type='date' className='form-control required-input' name="start_date" placeholder='Select Date' value={formData.start_date}
onChange={handleChange} />
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-lg-4 col-md-12">
<label>End Date</label>

<div className="form-group required-tooltip">



<input type='date'  className='form-control required-input' name="end_date" value={formData.end_date}
onChange={handleChange} />
{/* <Datepicker name="todate" value={formData.todate}
onChange={handleChange}></Datepicker> */}
{/* <div className="input-"  name="to_date" value={formData.to_date}
onChange={handleChange}>


</div> */}
</div>
</div>

<div className="col-lg-4 col-md-12">
<div className="form-group required-tooltip">

<label>Company</label>

<select  className="form-control custom-select required-select" id="company_id"   name='company_id' value={formData.leave_type} onChange={handleChange}>
  <option value="" disabled>Select Company</option>
  <option></option>

  <option value={1}>Annai Arul hospital</option>

</select>
</div>

</div>


<div className="col-lg-4 col-md-12">
<div className="form-group required-tooltip">

<label>Status</label>

<select  className="form-control custom-select required-select" id="status"   name='status' value={formData.status} onChange={handleChange}>
  <option value="" disabled>Select  status</option>
  <option></option>

  <option value={1}>Published</option>

  <option value={0}>Un Published</option>

</select>
</div>

</div>
<div className="col-lg-12 col-md-12">
<label>Description</label>

<div className="form-group required-tooltip">
<textarea
rows={4}
type="text"
className="form-control required-input"
placeholder="description"
name="description" value={formData.reason}
onChange={handleChange}
/>
</div>
</div>
<div className="col-lg-2 col-md-12 d-flex align-items-end">
<button type="submit" className="btn btn-primary btn-sm" disabled={isSaving}>
{isSaving ? "Saving..." : "Save"}
</button>
</div>
</div>

</div>

</div>


</div>

</form>

</div>
</div>


<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
<div className="card-header">
<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
<i className="fa fa-calendar mr-2" style={{ fontSize: "20px" }} />
Holiday List
</h3>
<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

<div className="input-group" style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>

<div style={{ marginRight: '15px' }}>
<EntriesSelector
entriesPerPage={itemsPerPage}
setEntriesPerPage={setItemsPerPage}
setCurrentPage={setCurrentPage}
/>
</div>

<div style={{ position: "relative", width: "300px" }}>

<input
type="text"
className="form-control form-control-sm"
placeholder="Search"
value={searchTerm}
onChange={handleSearch}
style={{
width: "100%",
height: "30px",              // same metrics as EntriesSelector's select
padding: "3px 8px",
paddingRight: "30px", // Extra space for the clear icon
fontSize: "13px",
boxSizing: "border-box",
}}
// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
/>

{searchTerm.length>0 && ( 
<span
onClick={clearInput}
style={{
position: "absolute",
top: "50%",
right:"10px",
transform: "translateY(-50%)",
cursor: "pointer",
color: "#aaa",
fontSize: "18px",
// marginLeft: '260px !important',

}}
>
✖
</span>
)}
</div>



</div>

</div>
</div>












<div className="card-body">
<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "420px" }}>
<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
<thead>
<tr>
<th>S.No</th>
<th>Event Name</th>
<th>Status</th>
<th>Start Date</th>
<th>End Date</th>
<th>Action</th>
</tr>
</thead>
<tbody>



{
filteredData.map((table, index) => {

return <tr key={index}>
<td className="d-flex">
<span
className="avatar avatar-blue"
data-toggle="tooltip"
data-original-title="Avatar Name"
>
{startIndex + index + 1}
</span>

</td>
<td>
<span>{table.event_name}</span>
</td>
<td>
<span>{table.status}</span>
</td>
<td>
<span>{table.start_date}</span>
</td>
<td>
<span>{table.end_date}</span>
</td>

<td>



<button
type="button" onClick={() =>{ handleUpdate(table.holiday_id);setUser(emptyUser)}}
className="btn btn-icon btn-sm"
title="Edit" data-toggle="modal"
data-target="#exampleEditModal"
>
<i className="fa fa-edit" />
</button>

</td>
</tr>


})
}

</tbody>
</table>
</div>



<Pagination
currentPage={currentPage}
totalPages={totalPages}
onPageChange={setCurrentPage}
/>









</div>
</div>
</div>


</div>
</div>
</div>

</div>
</div>





<div
className="modal fade"
id="exampleModal"
tabIndex={-1}
role="dialog"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>

</div>




<div
className="modal fade"
id="exampleEditModal"
tabIndex={-1}
role="dialog"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>
<form onSubmit={handleEditSubmit}>
<div className="modal-dialog" role="document">
<div className="modal-content">
<div className="modal-header">
<h5 className="modal-title" id="exampleModalLabel">
Edit Holiday
</h5>
<button type="button" className="close" data-dismiss="modal" aria-label="Close">
<span aria-hidden="true">×</span>
</button>
</div>
<div className="modal-body">
<div className="row clearfix">
<div className="col-md-6 col-sm-6">
<div className="form-group required-tooltip">
<label className="form-label">Holiday</label>
<input type="text" className="form-control required-input" name="event_name" value={user.event_name}
onChange={handelInput} placeholder="Holiday Name" />
</div>
</div>
<div className="col-md-6 col-sm-6">
<label>Start Date</label>

<div className="form-group required-tooltip">

<input type='date' className='form-control required-input' name="start_date" placeholder='Select Date' value={user.start_date}
onChange={handelInput} />
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-md-6 col-sm-6">
<label>End Date</label>

<div className="form-group required-tooltip">

<input type='date' className='form-control required-input' name="end_date" placeholder='Select Date' value={user.end_date}
onChange={handelInput} />
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-md-6 col-sm-6">
<div className="form-group required-tooltip">

<label>Status</label>

<select  className="form-control custom-select required-select" id="status"   name='status' value={user.status} onChange={handelInput}>
  <option value="" disabled>Select Status</option>
  <option></option>

  <option value={1}>Published</option>

  <option value={0}>Un Published</option>

</select>
</div>

</div>

</div>
</div>
<div className="modal-footer">
<button type="button" className="btn btn-secondary" data-dismiss="modal">
Close
</button>
<button type="submit" className="btn btn-primary" disabled={isUpdating}>
{isUpdating ? "Saving..." : "Save"}
</button>
</div>
</div>
</div>

</form>

</div>




<div
className="modal fade"
id="exampleEditModal1"
tabIndex={-1}
role="dialog"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>


</div>






</>
);

}



const mapStateToProps = (state) => ({
fixNavbar: state.settings.isFixNavbar,
statisticsOpen: state.settings.isStatistics,
statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
statisticsAction: (e) => dispatch(statisticsAction(e)),
statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Holiday);